
export const services = {
  hero: {
    description: 'KOMPLEXNÉ ENERGETICKÉ RIEŠENIA PRE PLYN, ELEKTRINU A PODNIKOVÉ PORADENSKÉ SLUŽBY'
  },
  list: {
    title: 'Naše kategórie služieb',
    subtitle: 'Profesionálne energetické riešenia prispôsobené potrebám vášho podnikania'
  },
  gas: {
    title: 'PLYN',
    smallBusiness: {
      title: 'Malé podniky',
      rights: 'Informácie o právach a povinnostiach konečného odberateľa plynu.',
      checklist: 'Kontrolný zoznam pre európskeho spotrebiteľa energie'
    },
    otherBusiness: {
      title: 'Ostatné podnikateľské subjekty',
      rights: 'Informácie o právach a povinnostiach konečného odberateľa plynu',
      checklist: 'Kontrolný zoznam pre európskeho spotrebiteľa energie.'
    },
    households: {
      title: 'Domácnosti',
      rights: 'Informácie o právach a povinnostiach konečného odberateľa plynu',
      checklist: 'Kontrolný zoznam pre európskeho spotrebiteľa energie.'
    }
  },
  electricity: {
    title: 'ELEKTRINA',
    smallBusiness: {
      title: 'Malé podniky',
      rights: 'Informácie o právach a povinnostiach konečného odberateľa elektriny',
      checklist: 'Kontrolný zoznam pre európskeho spotrebiteľa energie.',
      environmental: 'Vplyv na životné prostredie pri výrobe elektriny nakúpenej alebo vyrobenej dodávateľom za účelom jej dodávky odberateľom elektriny.',
      impact: 'Informácie o vplyve na životné prostredie pri výrobe elektriny'
    },
    otherBusiness: {
      title: 'Ostatné podnikateľské subjekty',
      rights: 'Informácie o právach a povinnostiach konečného odberateľa elektriny',
      checklist: 'Kontrolný zoznam pre európskeho spotrebiteľa energie',
      environmental: 'Vplyv na životné prostredie pri výrobe elektriny nakúpenej alebo vyrobenej dodávateľom za účelom jej dodávky odberateľom elektriny',
      impact: 'Informácie o vplyve na životné prostredie pri výrobe elektriny'
    },
    households: {
      title: 'Domácnosti',
      rights: 'Informácie o právach a povinnostiach konečného odberateľa plynu',
      checklist: 'Kontrolný zoznam pre európskeho spotrebiteľa energie.'
    }
  },
  consulting: {
    title: 'PODNIKOVÉ PORADENSTVO',
    services: {
      title: 'Poradenské služby',
      strategic: 'Strategické plánovanie podnikania a analýza trhu',
      operational: 'Operačná efektívnosť a optimalizácia procesov',
      compliance: 'Regulačná zhoda a riadenie rizík',
      market: 'Stratégie vstupu na trh a rozvoj podnikania'
    }
  }
};
